export default __webpack_public_path__ + "static/media/netcarbs@3x.9b8b603f.jpg";